import { useEffect, useState } from 'react';

const isDark = () =>
	typeof document !== 'undefined' &&
	document.body.classList.contains('dark-mode');

/**
 * Tema EFETIVO do checkout: o que está de fato aplicado no `<body>`.
 *
 * Quem decide o tema é uma pilha — o padrão da plataforma, sobrescrito pelo
 * tema da página montada no builder (`settings.theme`), e no preview do
 * builder ainda muda a cada clique. Ler só `customization.theme` acerta o
 * primeiro degrau e erra os outros: com página "Claro" numa plataforma
 * escura, o texto dos termos saía branco sobre cartão branco.
 *
 * A classe `dark-mode` no body é o resultado final dessa pilha; observá-la é
 * a única leitura que não precisa reimplementar a regra.
 */
export const useIsDarkMode = (): boolean => {
	const [dark, setDark] = useState(isDark);

	useEffect(() => {
		const sync = () => setDark(isDark());
		const observer = new MutationObserver(sync);
		observer.observe(document.body, {
			attributes: true,
			attributeFilter: ['class']
		});
		sync();
		return () => observer.disconnect();
	}, []);

	return dark;
};
